(() => {
	function getCurrencySign() {
		const currencySignHolder = document.querySelector("[data-currency-sign]");
		return currencySignHolder.dataset.currencySign;
	}
	function formatPrice(price) {
		return price / 100;
	}
	if (!customElements.get("length-selector")) {
		class LengthSelector extends HTMLElement {
			constructor() {
				super();
				this.lengthEls = this.querySelectorAll("[data-length-option]");
				this.mainTitle = this.querySelector("[data-main-title]");
				this.defaultSubtitle = this.querySelector("[data-default-subtitle]")
				this.singleOptionSubtitle = this.querySelector("[data-single-option-subtitle]")

				this.onLengthClickHandle = this.onLengthClick.bind(this);

			}

			connectedCallback() {
				this.setEventListeners();
			}

			setEventListeners() {
				this.lengthEls.forEach((el) => el.addEventListener("click", this.onLengthClickHandle));
			}

			disconnectedCallback() {}

			onLengthClick(){
				this.mainTitle.style.color = "#121212"
			}

			setSubtitle(){
				const filteredLength = Array.from(this.lengthEls).filter((el) => !el.classList.contains("hidden-option"))
					if(filteredLength.length === 1){
						this.defaultSubtitle.classList.add("hidden")
						this.singleOptionSubtitle.classList.remove("hidden")
					}else{
						this.defaultSubtitle.classList.remove("hidden")
						this.singleOptionSubtitle.classList.add("hidden")
					}
			}
		}

		customElements.define("length-selector", LengthSelector);
	}

	if (!customElements.get("length-selector-list")) {
		class LengthSelectorList extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.setVariables();
				this.setEventListeners();
        this.firstRender()
			}

			disconnectedCallback() {}

			setVariables() {
				this.variantsSelects = document.querySelector("variant-radios");
				this.variants = this.variantsSelects.getVariantData();
				this.wrapper = this.closest("length-selector")
				this.lengthEls = this.querySelectorAll("[data-length-option]");
				this.metalOptions = document.querySelector(".custom-select--metal .custom-options-list") || document.querySelector(".custom-metal__two-tone-metals .custom-options-list");
				this.lengthType = this.wrapper.getAttribute("data-option-name")

        this.onMetalOptionClickHandle = this.onMetalOptionClick.bind(this);
				this.onLengthClickHandle = this.onLengthClick.bind(this)

				this.searchParam = this.lengthType == "Chain Length" ? "chain-length" : "bracelet-length"
			}

			setEventListeners() {
        this.metalOptions.addEventListener("click", this.onMetalOptionClickHandle);
				this.lengthEls.forEach((el) => el.addEventListener("click", this.onLengthClickHandle));
      }

			displayLengthPrice() {}

			getActiveMetal() {
				return this.metalOptions.querySelector(".custom-option.active input").value;
			}

			getFullVariantsByMetal(metal) {
				return this.variants.filter((variant) => variant.options.includes(metal));
			}

			minMetalPrice(metal) {
				const metalVariants = this.variants.filter((variant) => variant.title.includes(metal));
				const minPrice = Math.min(...metalVariants.map((variant) => variant.price));
				return minPrice;
			}

			displayLengthPrice(activeMetal, filteredLengthEls) {
				const fullVariants = this.getFullVariantsByMetal(activeMetal);
				const minMetalPrice = this.minMetalPrice(activeMetal);

				filteredLengthEls.map((lengthEl) => {
					const priceEl = lengthEl.querySelector("[data-length-price]");
					const option = lengthEl.getAttribute("data-length-option");
					const validVariant = fullVariants.find((variant) => variant.options.includes(option));
					const variantPrice = validVariant.price;

					const priceDecrement = Number(variantPrice) - Number(minMetalPrice);

					priceEl.textContent = priceDecrement
						? `+${getCurrencySign()}${formatPrice(priceDecrement)}`
						: "";
				});
			}

			getLengthByMetal(metal) {
				return Array.from(this.lengthEls).filter((lengthEl) => {
					const option = lengthEl.getAttribute("data-length-option");
					const isValid = this.variants.find(
						(variant) => variant.options.includes(metal) && variant.options.includes(option),
					);
					lengthEl.classList.toggle("hidden-option", !isValid);
					return isValid;
				});
			}

      onMetalOptionClick(event){
        const activeMetalEl = event.target.closest(".custom-option");
				if (!activeMetalEl) return;

        const activeMetalInput = activeMetalEl.querySelector("input");
        const activeMetal = activeMetalInput.value;
        const filteredLengthEls = Array.from(this.getLengthByMetal(activeMetal));
        this.displayLengthPrice(activeMetal, filteredLengthEls);
				this.wrapper.setSubtitle()
      }

			onLengthClick(event){
				const currentElement = event.currentTarget;
				this.lengthEls.forEach((el) => {
					const isCurrent = el === currentElement;
					el.classList.toggle("active", isCurrent);
				});
			}

      firstRender(){
        const activeMetal = this.getActiveMetal()
        const filteredLengthEls = Array.from(this.getLengthByMetal(activeMetal));
				this.wrapper.setSubtitle()
        this.displayLengthPrice(activeMetal, filteredLengthEls);

				const params = new URL(document.location).searchParams;
				const length = params.get(this.searchParam);

				if(filteredLengthEls.length === 1){
					filteredLengthEls[0].click()
				}else if(length){
					const activeLength = filteredLengthEls.find(el=>{
						const value = el.getAttribute("data-length-option").replace("+", "").replace(/ +/g, " ");
						const formattedLength = length.replace(/ +/g, ' ')
						return value == formattedLength
					})
					if(activeLength){
						activeLength.click()
					}
				}

      }
		}

		customElements.define("length-selector-list", LengthSelectorList);
	}
})();
